import Qs from "qs";
import SelectAgent from "components-for/filters/select-agent";
import { clearUrlParameters } from "@edgetier/utilities";
import { faUser } from "@fortawesome/pro-solid-svg-icons";
import { faUsers } from "@fortawesome/pro-solid-svg-icons";
import { FieldInline, LabeledField, useQueryParameters } from "@edgetier/client-components";
import { Form, Formik, FormikValues } from "formik";
import { FunctionComponent, memo, useCallback } from "react";
import { INTERACTIONS_TABLE_PREFIX } from "constants/interactions";
import { IProps } from "./agent-filter.types";
import { parseUrlArray } from "@edgetier/utilities";
import { SubmitOnChange } from "@edgetier/components";
import { useHistory, useLocation } from "react-router-dom";
import "./agent-filter.scss";

/**
 * Select an agent and then populate the page with default filters.
 * @param props.defaultFilters
 * @returns Agent select.
 */
const AgentFilter: FunctionComponent<IProps> = ({ defaultFilters }) => {
    const { push } = useHistory();
    const { search } = useLocation();
    const { comparisonAgentId, reviewAgentId } = useQueryParameters({
        comparisonAgentId: parseUrlArray,
        reviewAgentId: String,
    });

    /**
     * Update the URL when the form values change.
     * @param values Form values.
     */
    const onChange = useCallback(
        (values: FormikValues) => {
            const parameters = Qs.parse(search, { ignoreQueryPrefix: true });
            const clearedSearchParameters = clearUrlParameters(parameters, INTERACTIONS_TABLE_PREFIX);
            const initialFilters = "reviewAgentId" in parameters ? {} : defaultFilters;

            const filterValues = { ...initialFilters, ...clearedSearchParameters, ...values };
            push(Qs.stringify(filterValues, { addQueryPrefix: true, arrayFormat: "repeat" }));
        },
        [defaultFilters, push, search]
    );

    return (
        <Formik initialValues={{ comparisonAgentId, reviewAgentId }} onSubmit={onChange}>
            <Form className="agent-filter" name="agent-filter">
                <LabeledField label="Review Agent" name="reviewAgentId">
                    <FieldInline icon={faUser}>
                        <SelectAgent isSingleSelect name="reviewAgentId" />
                    </FieldInline>
                </LabeledField>

                <LabeledField label="Comparison Agents" name="comparisonAgentId">
                    <FieldInline icon={faUsers}>
                        <SelectAgent isClearable name="comparisonAgentId" />
                    </FieldInline>
                </LabeledField>

                <SubmitOnChange delay={0} />
            </Form>
        </Formik>
    );
};

export default memo(AgentFilter);
